export default {
  stats: (state) => state.models,
  statByKey: (state) => (key) =>
    state.models.find((model) => model.getKey() === key),
  stats_pending: (state) => state.models_pending
}
